import * as React from "react";
const SvgFiRrWorld = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-world_svg__a)">
      <path
        fill="#062147"
        d="M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0m10 12a9.94 9.94 0 0 1-1.662 5.508l-1.192-1.193a.5.5 0 0 1-.146-.353V15a3 3 0 0 0-3-3h-3a1 1 0 0 1-1-1v-.5a.5.5 0 0 1 .5-.5A2.5 2.5 0 0 0 15 7.5v-1a.5.5 0 0 1 .5-.5h1.379a2.52 2.52 0 0 0 1.767-.732l.377-.377A9.97 9.97 0 0 1 22 12m-19.951.963 3.158 3.158A2.98 2.98 0 0 0 7.329 17H10a1 1 0 0 1 1 1v3.949a10.016 10.016 0 0 1-8.951-8.986M13 21.949V18a3 3 0 0 0-3-3H7.329a1 1 0 0 1-.708-.293l-4.458-4.458A9.978 9.978 0 0 1 17.456 3.63l-.224.224a.5.5 0 0 1-.353.146H15.5A2.5 2.5 0 0 0 13 6.5v1a.5.5 0 0 1-.5.5 2.5 2.5 0 0 0-2.5 2.5v.5a3 3 0 0 0 3 3h3a1 1 0 0 1 1 1v.962c.002.662.265 1.297.732 1.767l1.337 1.337A9.97 9.97 0 0 1 13 21.949"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-world_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWorld;
